// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"e8a78251","104":"2c879984"}[chunkId] + ".chunk.js";
};